import { render, staticRenderFns } from "./CashmgtSettings.vue?vue&type=template&id=6580e266&"
import script from "./CashmgtSettings.vue?vue&type=script&lang=js&"
export * from "./CashmgtSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports